import React from "react";
import { BsLinkedin, BsFacebook } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://www.linkedin.com/in/maty/" target="_blank">
        <BsLinkedin />
      </a>
      <a href="https://github.com/MatyMusic" target="_blank">
        <FaGithub />
      </a>
      <a href="https://www.facebook.com/maty770" target="_blank">
        <BsFacebook />
      </a>
    </div>
  );
};

export default HeaderSocials;
